import React, { useState } from "react";
import { Box, Typography, Button, Dialog, IconButton } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import CloseIcon from "@material-ui/icons/Close";

const getBase = () => process.env.REACT_APP_BACKEND_URL || '';
const getMediaUrl = (relPath, companyId) => {
  const base = getBase();
  if (!relPath) return '';
  if (relPath.startsWith('http')) return relPath;
  if (relPath.includes('public/')) {
      return `${base}/public/${relPath.split('public/')[1]}`;
  }
  if (relPath.startsWith('ai_img_')) return `${base}/public/company${companyId || 1}/campaigns/${relPath.split('/').pop()}`;
  if (relPath.startsWith('/campaigns/')) return `${base}/public/company${companyId || 1}${relPath}`;
  return `${base}/public/company${companyId || 1}/files/${relPath.split('/').pop()}`;
};

const AiPromptViewer = ({ prompt, companyId, compact = false }) => {
  const [zoomImage, setZoomImage] = useState(null);

  if (!prompt) return null;

  let cleanText = prompt;
  let refImg = null;
  let genImgs = [];

  try {
    if (cleanText.includes("|||GEN_IMGS|||")) {
      const parts = cleanText.split("|||GEN_IMGS|||");
      cleanText = parts[0];
      genImgs = JSON.parse(parts[1] || "[]");
    }
    if (cleanText.includes("|||REF_IMG|||")) {
      const parts = cleanText.split("|||REF_IMG|||");
      cleanText = parts[0];
      refImg = parts[1];
    }
  } catch (err) {
    console.error("Error parsing AI prompt data", err);
  }

  const textStyle = compact 
    ? { fontSize: "0.85rem", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", lineHeight: 1.2, whiteSpace: "pre-wrap", wordBreak: "break-word" }
    : { whiteSpace: "pre-wrap", wordBreak: "break-word" };

  const handleDownload = (img) => {
    const url = getMediaUrl(img.rawMediaUrl || img.imageUrl, companyId);
    
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = (img.rawMediaUrl || "imagen_generada.jpg").split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(() => {
        window.open(url, "_blank");
      });
  };

  return (
    <Box>
      <Box style={textStyle} title={cleanText}>
        {cleanText}
      </Box>

      {refImg && (
        <Box mt={2}>
          <Typography variant="caption" style={{ fontWeight: 700, color: "#aaa" }}>IMAGEN DE REFERENCIA</Typography>
          <Box mt={1}>
            <img src={refImg} alt="Reference" style={{ width: compact ? 64 : 100, height: compact ? 64 : 100, objectFit: "contain", borderRadius: 8, border: "1px solid #ccc", background: "#000" }} />
          </Box>
        </Box>
      )}

      {genImgs && genImgs.length > 0 && (
        <Box mt={2}>
          <Typography variant="caption" style={{ fontWeight: 700, color: "#00e5ff", textTransform: "uppercase" }}>IMÁGENES GENERADAS ({genImgs.length})</Typography>
          <Box display="flex" flexWrap="wrap" style={{ gap: compact ? 8 : 16, marginTop: 8 }}>
            {genImgs.map((img, i) => {
              const fullUrl = getMediaUrl(img.rawMediaUrl || img.imageUrl, companyId);
              return (
                <Box key={i} style={{ position: "relative", width: compact ? 120 : 150, borderRadius: 8, overflow: "hidden", border: "1px solid rgba(255,255,255,0.1)", background: "#000" }}>
                  <img 
                    src={fullUrl} 
                    alt={`Gen ${i}`} 
                    style={{ width: "100%", height: compact ? 120 : 150, objectFit: "contain", display: "block", cursor: "pointer" }} 
                    onClick={() => setZoomImage(fullUrl)}
                  />
                  <Box 
                    style={{ 
                      background: "rgba(0,0,0,0.6)", padding: 4, display: "flex", justifyContent: "space-around", alignItems: "center"
                    }}
                  >
                    <IconButton size="small" style={{ color: "#fff" }} onClick={() => setZoomImage(fullUrl)}>
                      <ZoomInIcon fontSize="small" />
                    </IconButton>
                    <Button 
                      size="small" 
                      startIcon={<GetAppIcon />} 
                      style={{ color: "#00e5ff", fontSize: "0.75rem", fontWeight: "bold", padding: "2px 8px" }}
                      onClick={() => handleDownload(img)}
                    >
                      Descargar
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}

      <Dialog open={Boolean(zoomImage)} onClose={() => setZoomImage(null)} maxWidth="md" fullWidth>
        <Box style={{ position: "relative", background: "#000", minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <IconButton 
            onClick={() => setZoomImage(null)} 
            style={{ position: "absolute", top: 8, right: 8, color: "#fff", background: "rgba(0,0,0,0.5)" }}
          >
            <CloseIcon />
          </IconButton>
          {zoomImage && (
            <img src={zoomImage} alt="Zoom" style={{ maxWidth: "100%", maxHeight: "85vh", objectFit: "contain" }} />
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default AiPromptViewer;
